import { createFileRoute } from "@tanstack/react-router";
import { ConceptLanding } from "@/components/site/ConceptLanding";
export const Route = createFileRoute("/foretag/")({
  head: () => ({
    meta: [
      { title: "Företagsevent – kickoff, mingel & företagsfest | Event Sverige" },
      {
        name: "description",
        content:
          "Koncept för kickoff, företagsmingel, lagkamp och arkadfest. Vi planerar, riggar och leder aktiviteterna. Stämningsljus ingår. Samlad offert före bokning.",
      },
    ],
    links: [{ rel: "canonical", href: "https://eventsverige.se/foretag" }],
  }),
  component: () => <ConceptLanding segment="foretag" />,
});
